import React from "react";
import * as Scrivito from "scrivito";
import { Button } from "reactstrap";
import { Icon, ProjectDetailsModal } from "components";
import { ProjectCreateMut, SameProjectCreateMut } from "api/mutations";
import { show } from "@ebay/nice-modal-react";
import { useTranslate } from "hooks";
import { useNavigateToProject } from "hooks/projectHooks";
import { useAppBaseContext } from "providers";

const NewProjectButtonComponent = Scrivito.connect(() => {
  const translate = useTranslate();
  const navigateToProject = useNavigateToProject();
  const { isSameProj } = useAppBaseContext();

  const toggleModal = () => {
    show(ProjectDetailsModal, {
      mutation: isSameProj ? SameProjectCreateMut : ProjectCreateMut,
    }).then(({ id }) => navigateToProject.configurator(id));
  };

  return (
    <Button
      data-testid="NEW_PROJECT_BUTTON_TEXT"
      onClick={toggleModal}
      color="primary"
      className="d-flex align-items-center"
    >
      <Icon prefix="trox" iconName="plus-regular" className="icon-16 me-1" />
      {translate("NEW_PROJECT_BUTTON_TEXT")}
    </Button>
  );
});

export const NewProjectButton = React.memo(NewProjectButtonComponent);
